import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 1.7rem 1.5rem;
  border-radius: 1rem;
  border: 2px solid #6b6b6b6b;
  background-color: #fff;
  color: #000000;
  text-align: center;

  p {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  h1 {
    font-size: 24px;
    font-weight: bold;
  }
  @media (max-width: 2000px) {
    padding: 1.5rem 0.5rem;

    p {
      font-size: 12px;
      font-weight: 600;
      margin-bottom: 1rem;
    }
    h1 {
      font-size: 20px;
      font-weight: bold;
    }
  }
  @media (max-width: 1366px) {
    p {
      font-size: 10px;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }
    h1 {
      font-size: 20px;
      font-weight: bold;
    }
  }
  @media (max-width: 415px) {
    padding: 0.5rem;
    border-radius: 0.5rem;
    p {
      font-size: 8px;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }
    h1 {
      font-size: 12px;
      font-weight: bold;
    }
  }
`;
